import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type StoreService from 'scaleflow/services/store';
import type IntlService from 'ember-intl/services/intl';
import type GroupModel from 'scaleflow/models/group';

export default class SettingsGroupsListController extends Controller {
  @service declare store: StoreService;
  @service declare intl: IntlService;

  queryParams = ['search'];
  @tracked search = '';

  get groups() {
    let groups = this.model as GroupModel[];

    if (this.search) {
      groups = groups.filter((group: GroupModel) => {
        return (group.title ?? '')
          .toLowerCase()
          .includes(this.search.toLowerCase());
      });
    }

    return groups;
  }

  @action
  deleteGroup(group: GroupModel) {
    void group.destroyRecord();
  }
}
